let intro_panel = document.querySelector('.intro-panel')
let first_panel = document.querySelector('.first-panel')
let second_panel = document.querySelector('.second-panel')
let third_panel = document.querySelector('.third-panel')
let fourth_panel = document.querySelector('.fourth-panel')
let nav = document.querySelector('nav')
let footer = document.querySelector('footer')
let checkbox = document.querySelector('.skip-checkbox')
let starting_btn = document.querySelector('.starting-btn')
if (localStorage.getItem('skip') == null) {
    localStorage.setItem('skip', false)
} else {
    if (localStorage.getItem('skip') === 'true') {
        checkbox.checked = true
        skipAnimations()
    } else {
        checkbox.checked = false
    }
}

checkbox.addEventListener('change', event => {
    if (event.currentTarget.checked) {
        localStorage.setItem('skip', true)
    } else {
        localStorage.setItem('skip', false)
    }
})
function skipAnimations() {
    document.documentElement.scrollTop = 0
    intro_panel.parentNode.removeChild(intro_panel)

    first_panel.classList.remove('opacity', 'height', 'padding') //showing first panel
    first_panel.classList.add('animate__animated', 'animate__fadeIn')

    second_panel.classList.remove('opacity', 'height', 'padding') //showing second panel
    second_panel.classList.add('animate__animated', 'animate__fadeIn')

    third_panel.classList.remove('opacity', 'height', 'padding') //showing third panel
    third_panel.classList.add('animate__animated', 'animate__fadeIn')

    fourth_panel.classList.remove('opacity', 'height', 'padding') //showing fourth panel
    fourth_panel.classList.add('animate__animated', 'animate__fadeIn')

    nav.classList.add('animate__animated', 'animate__fadeIn') //showing nav
    nav.classList.remove('opacity')

    footer.style.position = 'relative'
    footer.classList.remove('animate__animated', 'animate__fadeOut') //footer in, on the bottom, after load
    footer.classList.add('animate__animated', 'animate__fadeIn')
}
export default self
